import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedAndNamedArtifactResource,
    IndirectlyVersionedAndNamedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum StandardPropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
}

export const StandardResourceSchema = IndirectlyVersionedAndNamedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.STANDARD).default(ResourceType.STANDARD),
    description: z.string(),
});
export const StandardMutationResourceSchema = getMutationSchema(StandardResourceSchema);

export type StandardResource = z.infer<typeof StandardResourceSchema>;

export const defaultStandardResource: StandardResource = {
    ...defaultIndirectlyVersionedAndNamedArtifactResource,
    resourceType: ResourceType.STANDARD,
    description: '',
};

export function useStandardActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/standard',
            ResourceType.STANDARD,
            StandardResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter('project/standard', ResourceType.STANDARD, StandardResourceSchema),
    };
}
